import { useCallback, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Dialog, DialogContent, Grid, Paper, Typography, Tooltip, Button } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined'
import CustomTable from '../../components/CustomTable/CustomTable'
import { getProducts } from '../../api/products.service'
import { useDispatch, useSelector } from 'react-redux'
import AddIcon from '@material-ui/icons/Add'
import ProductForm from './ProductForm'
import ProductDetails from './ProductDetails'
import FeedbackIcon from '@material-ui/icons/FeedbackOutlined'
import { toggleModalFullscreen } from '../../redux/features/modalSlice'
import AssignmentIcon from '@material-ui/icons/AssignmentOutlined'
import LabelIcon from '@material-ui/icons/LabelOutlined'
import VerifiedUserIcon from '@material-ui/icons/VerifiedUserOutlined'
import EcoIcon from '@material-ui/icons/EcoOutlined'
import EmojiFoodBeverageIcon from '@material-ui/icons/EmojiFoodBeverageOutlined'
import ExposurePlus1Icon from '@material-ui/icons/ExposurePlus1Outlined'
import ExposurePlus2Icon from '@material-ui/icons/ExposurePlus2Outlined'
import PhotoIcon from '@material-ui/icons/Photo'

const ProductsView = () => {
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [isModalDetailOpen, setIsModalDetailOpen] = useState(false)
  const [isModalFormOpen, setIsModalFormOpen] = useState(false)
  const [state, setState] = useState({
    data: [],
    columns: [],
    loading: false,
    pages: 0,
    page: 0,
    pageSize: 15,
    sorted: null,
    filtered: [],
    createModal: true,
    hasChanges: true
  })
  const providerSelected = useSelector((state) => state.provider)
  const modal = useSelector((state) => state.modal)
  const dispatch = useDispatch()

  const [tableLoading, setTableLoading] = useState(true)

  const fileTypes = [
    {
      name: 'FichaProducto',
      tooltip: 'Ficha de producto',
      icon: <AssignmentIcon height="25" width="25" />
    },
    {
      name: 'Etiqueta',
      tooltip: 'Etiqueta',
      icon: <LabelIcon height="25" width="25" />
    },
    {
      name: 'FichaSeguridad',
      tooltip: 'Ficha de seguridad',
      icon: <VerifiedUserIcon height="25" width="25" />
    },
    {
      name: 'PuntoVerde',
      tooltip: 'Punto verde',
      icon: <EcoIcon height="25" width="25" />
    },
    {
      name: 'Azucar',
      tooltip: 'Azúcar',
      icon: <EmojiFoodBeverageIcon height="25" width="25" />
    },
    {
      name: 'Otro1',
      tooltip: 'Otro 1',
      icon: <ExposurePlus1Icon height="25" width="25" />
    },
    {
      name: 'Otro2',
      tooltip: 'Otro 2',
      icon: <ExposurePlus2Icon height="25" width="25" />
    },
    {
      name: 'Imagen',
      tooltip: 'Imagen',
      icon: <PhotoIcon height="25" width="25" />
    }
  ]

  const handleSetState = (values) => {
    const newState = { ...state, ...values, hasChanges: true }
    setState(newState)
  }

  const getData = useCallback(
    (nState) => {
      setTableLoading(true)
      const postObject = {
        providerId: providerSelected.id,
        ...(nState ? nState : state)
      }
      const data = JSON.stringify(postObject)
      getProducts(data)
        .then(({ data }) => {
          setState({
            ...state,
            page: postObject.page,
            sorted: postObject.sorted,
            filtered: postObject.filtered,
            pageSize: postObject.pageSize,
            data: data.results,
            pages: data.pageCount,
            hasChanges: false
          })
          setTableLoading(false)
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    [providerSelected.id, state]
  )

  const generateColumns = useCallback(() => {
    setState({
      ...state,
      columns: [
        {
          Header: 'Código artículo',
          accessor: 'articleCode',
          filterable: true,
          sortable: true,
          idSort: 'id',
          Cell: (props) => <span style={{ float: 'right' }}>{props.value}</span>
        },
        {
          Header: 'Cód. Art. Proveedor',
          accessor: 'providerArticleCode',
          filterable: true,
          sortable: true,
          Cell: (props) => <span style={{ float: 'right' }}>{props.value}</span>
        },
        {
          Header: 'Descripción',
          accessor: 'description',
          filterable: true,
          sortable: true,
          Cell: (props) => <span style={{ float: 'left' }}>{props.value}</span>
        },
        {
          Header: 'Documentos',
          accessor: 'documents',
          sortable: false,
          Cell: (props) => {
            const productCode = props.row.original.articleCode

            const documents = props.row.original.documents
              ? Object.entries(props.row.original.documents)
              : []
            if (props.row.original.imageUrl)
              documents.push([`${productCode}_Imagen`, props.row.original.imageUrl])

            return (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ display: 'flex' }}>
                  {fileTypes.map((fileType, index) => (
                    <span
                      key={`product-${productCode}-document-${index}`}
                      style={{ marginLeft: '1rem' }}
                    >
                      {documents.some((document) =>
                        document[0].includes(`${productCode}_${fileType.name}`)
                      ) ? (
                        documents
                          .filter((document) =>
                            document[0].includes(`${productCode}_${fileType.name}`)
                          )
                          .map((document) => (
                            <Tooltip
                              key={`file-type-${productCode}-${index}`}
                              title={fileType.tooltip}
                              onClick={() => window.open(document[1], '_blank')}
                              style={{ cursor: 'pointer' }}
                            >
                              {fileType.icon}
                            </Tooltip>
                          ))
                      ) : (
                        <div style={{ height: '25px', width: '25px' }} />
                      )}
                    </span>
                  ))}
                </div>
              </div>
            )
          }
        },
        {
          Header: '',
          accessor: 'details',
          sortable: false,
          Cell: (props) => (
            <span>
              <Tooltip title="Ver detalle del artículo">
                <VisibilityIcon
                  onClick={(e) => handleClickDetails(e, props.row.original.articleCode)}
                  height="25"
                  width="25"
                  style={{
                    cursor: 'pointer',
                    float: 'left',
                    marginLeft: '10px'
                  }}
                />
              </Tooltip>
            </span>
          ),
          width: 45
        },
        {
          Header: '',
          accessor: 'modificationRequest',
          sortable: false,
          Cell: (props) => (
            <span>
              {props.row.original.canBeEdited ? (
                <Tooltip title="Solicitar modificación">
                  <FeedbackIcon
                    onClick={(e) =>
                      handleClickModificationRequest(e, props.row.original.articleCode)
                    }
                    height="25"
                    width="25"
                    style={{
                      cursor: 'pointer',
                      float: 'left',
                      marginLeft: '10px'
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip title="Ya existe una modificación pendiente">
                  <FeedbackIcon
                    height="25"
                    width="25"
                    style={{
                      color: 'grey',
                      float: 'left',
                      marginLeft: '10px'
                    }}
                  />
                </Tooltip>
              )}
            </span>
          ),
          width: 45
        }
      ]
    })
  }, [state])

  useEffect(() => {
    if (state.hasChanges && state.columns.length > 0) getData()
  }, [getData, state.hasChanges])

  useEffect(() => {
    if (Object.entries(state.columns).length === 0) generateColumns()
  }, [state.columns, generateColumns])

  const handleClickDetails = (e, id) => {
    setSelectedProduct(id)
    setIsModalDetailOpen(true)
  }

  const handleClickModificationRequest = (e, id) => {
    setSelectedProduct(id)
    setIsModalFormOpen(true)
  }

  const fetchData = (nState) => {
    getData(nState)
  }

  const handleCloseModalDetail = () => {
    setIsModalDetailOpen(false)
  }

  const handleCloseModalForm = () => {
    setIsModalFormOpen(false)
  }

  const handleClickCreate = () => {
    setSelectedProduct(null)
    setIsModalFormOpen(true)
  }

  const exitFullscreenModal = useCallback(() => {
    if (!isModalDetailOpen && !isModalFormOpen && modal.showFullscreenOption) {
      dispatch(toggleModalFullscreen(false))
    }
  }, [isModalDetailOpen, isModalFormOpen, modal.showFullscreenOption, dispatch])

  useEffect(() => {
    let timeout = setTimeout(exitFullscreenModal, 500)
    return () => clearTimeout(timeout)
  }, [isModalDetailOpen, isModalFormOpen, exitFullscreenModal])

  return (
    <Paper style={{ padding: 16 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography color="secondary">ARTÍCULOS</Typography>
        </Grid>
        <Grid item xs={12} md={6} className="text-right">
          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<AddIcon fontSize={'small'} />}
            onClick={handleClickCreate}
          >
            Nuevo Artículo
          </Button>
        </Grid>
        <Grid item xs={12}>
          {state.loading ? (
            <p>
              <em>Cargando...</em>
            </p>
          ) : (
            <CustomTable
              {...state}
              numButtonColumns={0}
              tableLoading={tableLoading}
              fetchData={fetchData}
              handleSetState={handleSetState}
              filterProps={[
                { placeholder: 'Filtrar id...', id: 'id', value: '', width: 150 },
                {
                  placeholder: 'Filtrar código...',
                  id: 'providerArticleCode',
                  value: '',
                  width: 150
                },
                { placeholder: 'Filtrar descripción...', id: 'description', value: '', width: 200 },
                { width: 45, maxWidth: 45 },
                { width: 45, maxWidth: 45 },
                { width: 45, maxWidth: 45 }
              ]}
              manualSortBy={true}
            />
          )}
        </Grid>
      </Grid>
      <Dialog
        open={isModalDetailOpen}
        onClose={handleCloseModalDetail}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <ProductDetails id={selectedProduct} onClose={handleCloseModalDetail} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={isModalFormOpen}
        onClose={handleCloseModalForm}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <ProductForm id={selectedProduct} onClose={handleCloseModalForm} onSave={getData} />
        </DialogContent>
      </Dialog>
    </Paper>
  )
}

export default withRouter(ProductsView)
ProductsView.displayName = 'Artículos'
